import React, { useState, useEffect} from 'react'
import { useMobileLandscape } from '../../Context/ContextProvider'
import Lottie from 'lottie-react'
import rotateScreenAnimation from '../../assets/rotate-phone.json'
import FullWidthMobileButton from '../../components/FullWidthMobileButton';
import moment from 'moment'
import { CreateUrl, CallGetAPI } from 'Utils/ApiHelper.js';
import { APIGetLoggerConnectionsModel, buildAPIGetLoggerConnectionsModel } from "models/APIGetLoggerConnectionsModel";
import Loader from '../../Utils/Loader/NewLoader2025'
import { DataGrid, Column, Export, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, HeaderFilter, Selection, Sorting, DataGridTypes } from 'devextreme-react/data-grid';
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IntlShape, useIntl, FormattedMessage } from 'react-intl';
import DateBox, { ValueChangedEvent } from 'devextreme-react/date-box';


interface Props {
    history: {
        goBack: () => void;
    };
}


const ConnectionsPanelMobile: React.FC<Props> = ({history, serial}) => {

    ///hooks
    const isLandscape:boolean = useMobileLandscape()
    const intl: IntlShape = useIntl()

    ///useState
    const [startDate, setStartDate] = useState<Date>(moment().subtract(7, 'days').toDate())
    const [endDate, setEndDate] = useState<Date>(moment().toDate())
    const [connectionsData, setConnectionsData] = useState <APIGetLoggerConnectionsModel[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const reloadData = (): void => {
        setLoading(true)
        let connectionsDataTemp = new Array<APIGetLoggerConnectionsModel>();
        CallGetAPI(CreateUrl('/api/aquaguard/LoggerConnections?serial=' + serial + "&startDate=" + moment(startDate).format("yyyy-MM-DD") + "&endDate=" + moment(endDate).format("yyyy-MM-DD") + "T23:59:59"), {})
            .then(json => {
                connectionsDataTemp = connectionsDataTemp.concat(buildAPIGetLoggerConnectionsModel(json));
                setConnectionsData(connectionsDataTemp)
                setLoading(false)
            })
            .catch((err) => {
                console.error(err)
                setConnectionsData([])
                setLoading(false)
            });
    }

    ///initial loader
    useEffect(() => {
        reloadData()
    }, [])


 

    const startDateChanged = (e: ValueChangedEvent<Date | string | number>): void => {
        console.log(e)
        setStartDate(moment(e.value).toDate())
    }

    const endDateChanged = (e: ValueChangedEvent<Date | string | number>): void => {
        setEndDate(moment(e.value).toDate())
    }

    const renderDateTime = (data: DataGridTypes.ColumnCellTemplateData<APIGetLoggerConnectionsModel>, type: string):string => {
        if (type === 'connection') {
            return moment(data.data?.connectionTime).format('DD MMM YYYY hh:mm:ss')
        }
        if (type === 'rtc') {
            return moment(data.data?.rtcTime).format('DD MMM YYYY hh:mm:ss')
        }
    }


    return (
        <div>

            {!isLandscape &&
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40vh" }}>
                    <div>
                        <h4 style={{ textAlign: "center" }}><b><FormattedMessage id="Please rotate your screen" /></b></h4>
                        <h4 style={{ textAlign: "center" }}><b><FormattedMessage id="to view the full table" /></b></h4>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <Lottie animationData={rotateScreenAnimation} loop={true} style={{ width: "50%" }} />
                        </div>

                    </div>

                </div>
            }
            {isLandscape &&
                (loading ?
                    <div style={{
                        position: 'relative', left: 'Calc(50% - 100px)', top: 'Calc(50vh - 200px)'
                    }}>
                        <Loader color={undefined} />
                    </div>
                :
                <div>
                    {/*When rotated and loaded*/}
                    <GridContainer>
                        <div style={{ width: "100%", marginLeft: "30px", display: isLandscape ? 'flex' : 'block' }}>
                            <GridItem xs={12} sm={6} md={6}>
                                {intl.formatMessage({ id: "Start date" })} :&nbsp;<DateBox id="startDate" displayFormat={"dd/MM/yyyy"} value={startDate} onValueChanged={(e: ValueChangedEvent): void => startDateChanged(e)} />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}>
                                {intl.formatMessage({ id: "End date" })} :&nbsp;<DateBox id="endDate" displayFormat={"dd/MM/yyyy"} value={endDate} onValueChanged={(e: ValueChangedEvent): void => endDateChanged(e)} />
                            </GridItem>
                        </div>
                        <div style={{ margin: "20px 0 0 30px" }}>
                            <DataGrid
                                dataSource={connectionsData}
                                scrolling={{
                                    mode: 'standard',
                                    useNative: false
                                }}
                                allowColumnResizing={true}
                                allowColumnReordering={true}
                                style={{ border: "1px solid gray" }}
                            >
                                <FilterRow visible={true} />
                                <HeaderFilter visible={true} allowSearch={true} />
                                <Column dataField='clientEndPoint' dataType='string' caption={intl.formatMessage({ id: 'Connection Type' })} />
                                <Column dataField='connectionTime' dataType='datetime' cellRender={(data): string => renderDateTime(data, 'connection')} caption={intl.formatMessage({id: "Connection Time"})} />
                                <Column dataField='rtcTime' dataType='datetime' cellRender={(data): string => renderDateTime(data, 'rtc')} caption={intl.formatMessage({ id: "Device Time (UTC)"})} />
                                <Column dataField='latestRssi' dataType='number' caption={intl.formatMessage({ id: "Latest Signal" }) } />
                                <Column dataField='readBatteryChannel' dataType='number' caption={intl.formatMessage({id: 'Battery Voltage'}) } />
                            </DataGrid>
                        </div>
                    </GridContainer>

                </div>)
            }
        </div>
    )
}
export default ConnectionsPanelMobile